// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e74ab758","655":"051f9b04"}[chunkId] + ".chunk.js";
};